<main class="main">
  <page-header
    *ngIf="!(router.url === '/login' || router.url === '/forgotpassword' || router.url === '/createaccount' || router.url === '/resetpassword' || router.url === '/thanks')"></page-header>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</main>